import React from 'react';
import { useTranslation } from 'react-i18next';
import type { LandingStat } from '../types';

interface LandingStatsProps {
    data: LandingStat[];
}

/**
 * Stats row section showing key metrics.
 */
const LandingStats: React.FC<LandingStatsProps> = ({ data }) => {
    const { t } = useTranslation();

    return (
        <section className="relative py-16 bg-slate-900 border-y border-slate-800">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
                    {data.map((stat, index) => (
                        <div
                            key={index}
                            className="text-center group"
                        >
                            <div className="text-3xl sm:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-violet-400 to-indigo-400 bg-clip-text text-transparent mb-2 transition-transform group-hover:scale-110">
                                {stat.value}
                            </div>
                            <div className="text-sm sm:text-base text-slate-400 font-medium group-hover:text-slate-300 transition-colors">
                                {stat.label}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default LandingStats;
